import Button from "components/general/buttonv2";
import SvgIcon from "components/general/svgIcon";
import { downloadLinksArray } from "data/variables";
import styled from "styled-components";
import styles from "./banner.module.css";

const StyledGradientSpan = styled.span`
  background: linear-gradient(270deg, #7551cb 3.49%, #5172c8 92.38%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const StyledContainer = styled.div`
  width: 100%;
  max-width: 1280px;
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  align-items: center;
  padding: 1rem 2rem;
  h2 {
    font-size: 3rem;
    line-height: 4.2rem;
    font-weight: 700;
    width: 100%;
    text-align: center;
    margin-bottom: 0;
    margin: 0
  }
  p {
    text-align: center;
    font-size: 1.2rem;
    line-height: 2rem;
    margin-bottom: 4rem;
  }
  @media screen and (max-width: 1280px) {
    h2 {
      margin: 2rem 0 0 0;
    }
  }
  @media screen and (max-width: 992px) {
    h2 {
      line-height: 2.8rem;
      font-size: 2rem;
    }
  }
  @media screen and (max-width: 768px) {
    h2 {
      text-align: center;
    }
    text-align: center;
    margin-top: 0;
  }
`;

const StyledButtons = styled.div`
  display: flex;
  margin-left: 2rem;
  @media screen and (max-width: 768px) {
    justify-content: center;
  }
`;

const HomeSectionTwo = () => {
  return (
    <section className={styles.wrapper} style={{ background: "var(--background-color)" }}>
      <StyledContainer>
        <div className={styles.banner__wrapper}>
          <div
            className={styles.banner}
            style={{ background: "var(--raised-background-color)", gap: "2rem" }}
          >
            <h2>
              Connect. Manage. <StyledGradientSpan>Redact.</StyledGradientSpan>
            </h2>
            <div className={styles.button}>
              <Button
                wrapperStyle={{ textAlign: "center" }}
                to="/download"
                buttonPrimary={false}
                alignSelf="center"
              >
                Get Redact
              </Button>
              <StyledButtons style={{ marginTop: "2rem" }}>
                {downloadLinksArray.map((value) => {
                  return (
                    <div key={value.icon} className="hero__button_row__icon">
                      <SvgIcon name={value.icon} />
                    </div>
                  );
                })}
              </StyledButtons>
              <div className="hero__subtext">Available for Windows, MacOS, and Linux today</div>
            </div>
          </div>
        </div>
      </StyledContainer>
    </section>
  );
};

export default HomeSectionTwo;
